import React, { Component } from 'react';
import { isEmpty, getLocale } from '../../Common/Common';

export default class History_Dynamic_Data extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}

	render() {
		/*
		 * Filters index
		 * 0 = timestamp
		 * 1 = type
		 * 2 = command
		 * 3 = point id/function id
		 * 4 = data
		 * 5 = operator (i.e. who)
		 */
		if (this.props.type == 'system') {
			switch (this.props.command) {
				case 'login_fail':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString('login_fail') + ': ' + this.props.operator + ' ' + this.props.receiver.getString(this.props.data['result'])}</span>
						</div>
					)
					break;
				case 'login':
				case 'logout':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command) + ': ' + this.props.operator}</span>
						</div>
					)
					break;
				case 'find':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command) + ': '}</span>
							<div>
								<span className='subtitle'>{this.props.receiver.getString(this.props.data['dev']) + ' ' + this.props.target_id + ': '
									+ this.props.data['key']}</span>
							</div>
						</div>
					)
					break;
				case 'connect':
				case 'disconnect':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command) + ': '}</span>
							<div>
								<span className='subtitle'>{this.props.receiver.getString(this.props.data['dev']) + ': ' + this.props.target_id}</span>
							</div>
						</div>
					)
					break;
				case 'update':
				case 'ssc_con':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command) + ': '
								+ this.props.receiver.getString(this.props.data)}</span>
						</div>
					)
					break;
				case 'sys_start':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command) + ': '
								+ this.props.receiver.getString(this.props.data['model']) + ' ver.' + this.props.data['ver']}</span>
						</div>
					)
					break;
				case 'message':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString('mesg') + ': '
								+ this.props.receiver.getString(this.props.data)}</span>
						</div>
					)
					break;
				case 'not_registered':
					// 'not_registered' show zwave device not supported
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString('not_registered') + ': '
								+ this.props.receiver.getString(this.props.data['pro_name']) + ', '
								+ this.props.receiver.getString(this.props.data['manu_id']) + ', '
								+ this.props.receiver.getString(this.props.data['pro_id']) + ', '
								+ this.props.receiver.getString(this.props.data['pro_type'])}
							</span>
						</div>
					)
					break;
				default:
					return null;
			}
		} else if (this.props.type == 'func') {
			switch (this.props.command) {
				case 'changeover':
				case 'interlock':
				case 'scene':
				case 'schedule':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command) + ': '}</span>
							<div>
								<span className='subtitle'>{this.props.receiver.getString('exec') + ': ' + this.props.data['exec']}</span>
							</div>
						</div>
					)
					break;
				case 'ppd_calc':
					return (
						<div id='dynamic_data'>
							<span>{this.props.receiver.getString(this.props.command)}</span>
						</div>
					)
					break;
				default:
					return null;
			}
		} else if (this.props.type == 'cos') {
			let point_name = this.props.target_id;

			let point_info = window.app.state.point_list[this.props.target_id];
			if (!isEmpty(point_info)) point_name = point_info.name;

			let display_string = '';
			let temp_array = [];
			for (let key in this.props.data) {
				let val = this.props.data[key];
				// Only display value for on/off statuses
				if (key == 'stat') {
					if (!isEmpty(point_info)) {
						if (point_info.stat_word != null) {
							temp_array.push(this.props.receiver.getString(point_info.stat_word[val]));
						} else {
							temp_array.push(this.props.receiver.getString(val));
						}
					} else {
						temp_array.push(this.props.receiver.getString(val));
					}
				} else {
					temp_array.push(this.props.receiver.getString(key) + ': ' + this.props.receiver.getString(val));
				}
			}

			display_string = temp_array.join(', ');

			return (
				<div id='dynamic_data'>
					<span>{point_name + ': '}</span>
					<div>
						<span className='subtitle'>{display_string}</span>
					</div>
				</div>
			)
		} else if (this.props.type == 'error') {
			let point_name = this.props.target_id;

			let point_info = window.app.state.point_list[this.props.target_id];
			if (!isEmpty(point_info)) point_name = point_info.name;

			let error = this.props.data['error'];

			let display_string = '';
			let temp_array = [];
			for (let key in error) {
				if (error[key] == true) {
					temp_array.push(this.props.receiver.getString(key));
				} else {
					temp_array.push(this.props.receiver.getString('clear') + ': ' + this.props.receiver.getString(key));
				}
			}

			display_string = temp_array.join(', ');

			return (
				<div id='dynamic_data'>
					<span>{point_name + ': '}</span>
					<div>
						<span className='subtitle'>{display_string}</span>
					</div>
				</div>
			)
		} else if (this.props.type == 'alert') {
			let point_name = this.props.target_id;

			let point_info = window.app.state.point_list[this.props.target_id];
			if (!isEmpty(point_info)) point_name = point_info.name;

			let alert = this.props.data['alert'];

			let display_string = '';
			let temp_array = [];
			for (let key in alert) {
				if (alert[key] == true) {
					temp_array.push(this.props.receiver.getString(key));
				} else {
					temp_array.push(this.props.receiver.getString('clear') + ': ' + this.props.receiver.getString(key));
				}
			}

			display_string = temp_array.join(', ');

			return (
				<div id='dynamic_data'>
					<span>{point_name + ': '}</span>
					<div>
						<span className='subtitle'>{display_string}</span>
					</div>
				</div>
			)
		} else if (this.props.type == 'op') {
			let point_name = this.props.target_id;

			let point_info = window.app.state.point_list[this.props.target_id];
			if (!isEmpty(point_info)) point_name = point_info.name;

			let display_string = '';
			let temp_array = [];
			for (let key in this.props.data) {
				let val = this.props.data[key];
				temp_array.push(this.props.receiver.getString(key) + ': ' + this.props.receiver.getString(val));
			}

			display_string = temp_array.join(', ')

			return (
				<div id='dynamic_data'>
					<span>{point_name + ': '}</span>
					<div>
						<span className='subtitle'>{display_string}</span>
					</div>
				</div>
			)
		}
	}
}